import { gql } from '@apollo/client';

export const ORGANIZATION_CONTACTS_UPSERT = gql`
  mutation UpsertContacts($contacts: [UpsertOrganizationContactInput!]!) {
    upsertContacts(contacts: $contacts)
  }
`;
